import type { AddOperationPayload } from "types/Portfolio";
import type { BudgetTransaction } from "types/BudgetTransaction";
import { toAmount } from "features/groups";

export function buildBudgetTransactionFromPortfolioOperation(input: {
    username: string;
    payload: AddOperationPayload;
    liquidityPoolId: string;
}): BudgetTransaction | null {
    const { username, payload, liquidityPoolId } = input;
    if (!liquidityPoolId) return null;
    if (payload.side !== "buy" && payload.side !== "sell" && payload.side !== "amortization") return null;

    const total = toAmount(Number(payload.quantity) * Number(payload.price));
    const baseLabel = (payload.symbol?.trim() || payload.name?.trim() || "asset").toUpperCase();
    const opDate = payload.date ? new Date(payload.date) : new Date();
    const date = Number.isNaN(opDate.getTime()) ? Date.now().toString() : opDate.getTime().toString();

    return {
        _id: "",
        payer: username,
        date,
        name: `Portfolio ${payload.side.toUpperCase()} ${baseLabel}`,
        currency: payload.currency || "ARS",
        amount: total,
        type: payload.side === "buy" ? "expense" : "income",
        splitDetails: {},
        liquidityPoolId,
    };
}

